import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebookF, FaInstagram, FaTwitter, FaPinterestP } from 'react-icons/fa'

const topicsFromSanity = ['Hair Care', 'Skin Care', 'Nail Art', 'Makeup Tips']

const FooterSection = ({ title, links }) => (
    <div className="mb-8 md:mb-0">
        <h2 className="text-white text-lg font-semibold mb-4">{title}</h2>
        <ul className="space-y-2">
            {links.map((link) => (
                <li key={link.text}>
                    <Link
                        to={link.url}
                        className="text-white text-opacity-70 hover:text-opacity-100 transition-colors"
                    >
                        {link.text}
                    </Link>
                </li>
            ))}
        </ul>
    </div>
)

const SocialIcon = ({ Icon, url }) => (
    <Link
        to={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-white text-opacity-70 hover:text-opacity-100 transition-colors"
    >
        <Icon size={24} />
    </Link>
)

export default function Footer() {
    return (
        <footer className="bg-neutral-900 px-4 md:px-16 py-12">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
                    <div className="lg:col-span-2">
                        <Link to="/" className="flex items-center gap-3 text-white">
                            <img
                                src="/SalonXLogo.png"
                                alt="Salon Blog Logo"
                                className="w-auto h-10"
                            />

                        </Link>
                        <p className="mt-4 text-white text-opacity-80 leading-relaxed">
                            Your ultimate destination for expert beauty advice, trending styles, and the latest innovations in salon services. Elevate your look with Salon Blog.
                        </p>
                        <div className="mt-6 flex space-x-4">
                            <SocialIcon Icon={FaFacebookF} url="https://facebook.com" />
                            <SocialIcon Icon={FaInstagram} url="https://instagram.com" />
                            <SocialIcon Icon={FaTwitter} url="https://twitter.com" />
                            <SocialIcon Icon={FaPinterestP} url="https://pinterest.com" />
                        </div>
                    </div>
                    <FooterSection
                        title="Topics"
                        links={topicsFromSanity.map(topic => ({
                            text: topic,
                            url: `/topic/${topic.toLowerCase().replace(/\s+/g, '-')}`
                        }))}
                    />
                    <FooterSection
                        title="Your Account"
                        links={[{ text: 'Your Profile', url: '/profile' }]}
                    />
                    <FooterSection
                        title="Legal & Info"
                        links={[
                            { text: 'Terms & Conditions', url: '/terms' },
                            { text: 'Privacy Policy', url: '/privacy' },
                            { text: 'Sitemap', url: '/sitemap' }
                        ]}
                    />
                </div>
                <div className="mt-12 pt-8 border-t border-white border-opacity-20 text-center">
                    <p className="text-white text-opacity-70 text-sm">
                        © {new Date().getFullYear()} Salon X Blog. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}